import React, { useState } from 'react';

const COOKIE_TRANSLATIONS = {
  english:    { acceptAll: 'Accept All Cookies', rejectAll: 'Reject All' },
  irish:      { acceptAll: 'Accept All Cookies', rejectAll: 'Reject All' },
  portuguese: { acceptAll: 'Aceitar Todos os Cookies', rejectAll: 'Rejeitar Todos' },
  albanian:   { acceptAll: 'Prano të gjitha Cookies', rejectAll: 'Refuzo të gjitha' },
  german:     { acceptAll: 'Alle Cookies akzeptieren', rejectAll: 'Alle ablehnen' },
  spanish:    { acceptAll: 'Aceptar todas las cookies', rejectAll: 'Rechazar todas' },
  french:     { acceptAll: 'Accepter tous les cookies', rejectAll: 'Tout refuser' },
  italian:    { acceptAll: 'Accetta tutti i cookie', rejectAll: 'Rifiuta tutti' },
  dutch:      { acceptAll: 'Alle cookies accepteren', rejectAll: 'Alles weigeren' },
  greek:      { acceptAll: 'Αποδοχή όλων των Cookies', rejectAll: 'Απόρριψη όλων' },
  turkish:    { acceptAll: 'Tüm Çerezleri Kabul Et', rejectAll: 'Tümünü Reddet' },
  romanian:   { acceptAll: 'Acceptă toate cookie-urile', rejectAll: 'Respinge toate' },
  czech:      { acceptAll: 'Přijmout všechny cookies', rejectAll: 'Odmítnout vše' },
  hungarian:  { acceptAll: 'Összes süti elfogadása', rejectAll: 'Összes elutasítása' },
};

export default function SurveyCookieBanner({ surveyId, content, language, cookiePolicyData, onCookieDecision }) {
  const [visible, setVisible] = useState(true);
  const t = COOKIE_TRANSLATIONS[language] || COOKIE_TRANSLATIONS.english;

  const showAccept = cookiePolicyData?.accept_btn_enabled !== 0;
  const showReject = cookiePolicyData?.reject_btn_enabled !== 0;
  const acceptLabel = cookiePolicyData?.accept_btn_text || t.acceptAll;
  const rejectLabel = cookiePolicyData?.reject_btn_text || t.rejectAll;

  if (!visible) return null;

  const handleAccept = () => {
    setVisible(false);
    if (onCookieDecision) onCookieDecision('accepted');
  };

  const handleReject = () => {
    setVisible(false);
    if (onCookieDecision) onCookieDecision('rejected');
  };

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner">
        <div className="cookie-content">
          <div dangerouslySetInnerHTML={{ __html: content || '' }} />
          <div className="cookie-actions">
            {showAccept && (
              <button className="btn-accept" onClick={handleAccept}>{acceptLabel}</button>
            )}
            {showReject && (
              <button className="btn-reject" onClick={handleReject}>{rejectLabel}</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
